import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { UserService, DealerService, SpinnerService, FileuploadService, AuthenticationService } from '../services';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, FormsModule } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';
import { observable, Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';


@Component({ templateUrl: 'file-upload.component.html' })
export class FileuploadComponent {
  pageTitle: any;
  amgBucketKeyValue: any[];
  accessKeyId: string;
  region: string;
  secretAccessKey: string;
  xAmzBucket: any;
  xAmzServerSideEncryption: any;
  xAmzAlgorithm: any;
  xAmzAcl: any;
  xAmzMetaUuid: any;
  xAmzContent: any;
  createdBy: any;
  selectedFiles: FileList;
  listuploadForm: FormGroup;
  msgSuccess: any;
  currentUser: any;
  listpath: any;
  msgError: string;
  error: boolean;
  success: boolean;
  ListName: any;
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private fileuploadService: FileuploadService,
    private authenticationService: AuthenticationService,
    private spinnerService: SpinnerService) { }
  ngOnInit() {
    this.success = false;
    this.error = false;
    this.pageTitle = 'Kia Active Dealers List Upload';
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.listuploadForm = this.fb.group({
      ListName: [''],
      ListFile:['']
    });
    this.fileuploadService.getListAMGBucketKeys().subscribe(
      (data: any) => {
        this.amgBucketKeyValue = data.split('|');
        this.accessKeyId = this.amgBucketKeyValue[0].split(':')[1];
        this.region = this.amgBucketKeyValue[1].split(':')[1];
        this.secretAccessKey = this.amgBucketKeyValue[2].split(':')[1];
        this.xAmzBucket = this.amgBucketKeyValue[3].split(':')[1];
        this.xAmzServerSideEncryption = this.amgBucketKeyValue[5].split(':')[1];
        this.xAmzAlgorithm = this.amgBucketKeyValue[6].split(':')[1];
        this.xAmzAcl = this.amgBucketKeyValue[7].split(':')[1];
        this.xAmzMetaUuid = this.amgBucketKeyValue[8].split(':')[1];
        this.xAmzContent = this.amgBucketKeyValue[9].split(':')[1];
      },
      error => { this.spinnerService.stop(); }
    );
  }
  upload() {
    this.spinnerService.start();
    const file = this.selectedFiles.item(0);
    this.uploadFile(file);
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
    const file = this.selectedFiles.item(0);
    if(this.ListName == '' || this.ListName == undefined){
      this.ListName = file.name
    }
  }
  uploadFile(file) {
    this.success = false;
    this.error = false;
    const contentType = file.type;
    const bucket = new S3(
      {
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey,
        region: this.region
      }
    );
    const params = {
      Bucket: this.xAmzBucket,
      Key: CONFIGURATION.constants.ListBucketPath + file.name,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType
    };
    bucket.upload(params, function (err, data) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
      } else {
        console.log('Successfully uploaded file.', data);
      }
    });
    let listpath = CONFIGURATION.constants.listfileUploadUrl + CONFIGURATION.constants.ListBucketPath + file.name;
    let listname = this.listuploadForm.controls.ListName.value;
    if(listname == ''){
      listname = file.name;
    }
    this.fileuploadService.uploadDealerFile(listpath, listname, this.currentUser.userName).subscribe(
      (data: any) => {
        this.listuploadForm.patchValue({
          ListName: "",
          ListFile:""
        });
        this.success = true;
        this.msgSuccess = "Successfully uploaded file";
        setInterval(() => {
          this.success = false;
          window.location.reload(true)
        }, 3000);
        this.spinnerService.stop();
      },
      error => { 
        this.error = true;
        this.msgError = "There was an error uploading your file"
        setInterval(() => {
          this.error = false;
        }, 3000);
        this.spinnerService.stop(); 
      }
    );
    
  }

}